import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Header from './components/Header/Header';
import Connexion from './pages/Connexion/Connexion';
import Footer from './components/Footer/Foot';
import Simulateur from './pages/Home/Simulateur';
import Demo from './pages/Home/Demo';
import CountrySelectPage from './components/CountrySelect/CountrySelectPage';

import './App.css';
function App() {
  // Read saved country from localStorage if present, otherwise force selection
  const [country, setCountry] = useState(() => {
    try {
      return localStorage.getItem('yros_country') || null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    if (country) {
      try { localStorage.setItem('yros_country', country); } catch (e) {}
    }
  }, [country]);

  return (
    <Router>
        {country ? (
          <>
            <Header country={country} setCountry={setCountry} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/connexion" element={<Connexion />} />
              <Route path="/simulateur" element={<Simulateur country={country} setCountry={setCountry} />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="*" element={<h1>Page Not Found</h1>} />
            </Routes>
            <Footer />
          </>
        ) : null}

        {/* Force country selection page if no country chosen */}
        {country === null && <CountrySelectPage setCountry={setCountry} />}
      </Router>
  );
}

export default App;